var _path, _path2;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgUtility3(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 37,
    height: 36,
    viewBox: "0 0 37 36",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M13.1328 27.8893V34.082H21.8619C22.1674 34.0821 22.47 34.0219 22.7522 33.9051C23.0345 33.7882 23.291 33.6168 23.5071 33.4008L33.8166 23.0912C34.2536 22.6552 34.4996 22.0634 34.5005 21.4461V12.7305H28.3078V25.5603C28.3082 25.8683 28.2474 26.1733 28.1289 26.4576C28.0105 26.7419 27.8368 26.9999 27.6179 27.2166C27.399 27.4332 27.1392 27.6042 26.8537 27.7197C26.5681 27.8352 26.2625 27.8928 25.9545 27.8893H13.1328Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    d: "M23.865 8.2909V2.09814H15.1359C14.8304 2.0981 14.5279 2.15824 14.2456 2.27512C13.9633 2.392 13.7069 2.56334 13.4908 2.77935L3.1812 13.0889C2.96519 13.305 2.79386 13.5615 2.67697 13.8438C2.56009 14.126 2.49996 14.4286 2.5 14.7341V23.4578H8.69276V10.6172C8.69276 10.3115 8.75302 10.0088 8.8701 9.72637C8.98717 9.44394 9.15877 9.18738 9.37507 8.97132C9.59138 8.75526 9.84814 8.58396 10.1307 8.46721C10.4132 8.35046 10.716 8.29056 11.0218 8.2909H23.865Z",
    fill: "#37ABFF",
    stroke: "#37ABFF",
    strokeWidth: 2.27,
    strokeMiterlimit: 10
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgUtility3);
export default __webpack_public_path__ + "static/media/utility3.9f8c9fb615367f03ce33f49124212795.svg";
export { ForwardRef as ReactComponent };